import PropTypes from 'prop-types';
import MotifTextArea from '@ey/motif-react-wrapper/TextArea';
import React, {useState} from 'react';
import styled from 'styled-components';
import getRefPropType from '../../../util/PropTypes/getRefPropType';
import {isValidFunction} from '../../../util/utils';
import ErrorMessage from './MotifErrorMessage';

TextArea.propTypes = {
	autoFocus: PropTypes.bool,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	maxLength: PropTypes.number,
	minLength: PropTypes.number,
	name: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onClick: PropTypes.func,
	onKeyDown: PropTypes.func,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	required: PropTypes.bool,
	textAreaRef: getRefPropType(Element),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

TextArea.defaultProps = {
	autoFocus: false,
	className: 'styled-text-area',
	disabled: false,
	readOnly: false,
	required: false,
	value: ''
};

export default function TextArea({
	className,
	disabled,
	id,
	type,
	maxLength,
	minLength,
	name,
	onBlur,
	onChange,
	onClick,
	onFocus,
	onKeyDown,
	placeholder,
	readOnly,
	required,
	textAreaRef,
	value,
	textAreaError,
	textAreaErrorMessage,
	hideClearButton,
	labelPosition
}) {
	const [wasFocusedOnce, setWasFocusedOnce] = useState(false);

	function handleOnFocus(event) {
		const htmlEl = event?.target;
		if (!wasFocusedOnce) {
			/* Move cursor to the end */
			htmlEl.selectionStart = htmlEl.selectionEnd = htmlEl.value.length;
			setWasFocusedOnce(true);
		}
		if (isValidFunction(onFocus)) {
			onFocus(event);
		}
	}

	return (
		<>
			<StyledTextArea
				id={id}
				type={type}
				className={className}
				disabled={disabled}
				maxLength={maxLength}
				minLength={minLength}
				name={name}
				onBlur={onBlur}
				onChange={onChange}
				onClick={onClick}
				onFocus={handleOnFocus}
				onKeyDown={onKeyDown}
				placeholder={placeholder}
				readOnly={readOnly}
				ref={textAreaRef}
				required={required}
				value={value}
				hideClearButton={hideClearButton}
				spellcheck="false"
				labelPosition={labelPosition}
			/>
			{textAreaError && <ErrorMessage message={textAreaErrorMessage} />}
		</>
	);
}

const StyledTextArea = styled(MotifTextArea)`
	min-height: var(--px-90) !important;
	width: 100%;
	resize: none !important;
	&::-webkit-scrollbar {
		height: var(--px-6);
		width: var(--px-6);
	}
	&::-webkit-scrollbar-track {
		background: var(--neutrals-200);
		height: var(--px-6);
		width: var(--px-6);
	}
	&::-webkit-scrollbar-thumb {
		background: var(--neutrals-300);
		height: var(--px-6);
		width: var(--px-6);
		cursor: pointer;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: var(--neutrals-700);
	}
`;
